import React, { useEffect, useState } from "react";
import { SmartSoftForm, SmartValid, SmartFormInterFace } from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";
import { get, post } from "../../services/smartApiService";
import { showNotification } from "../../services/notifyService";
import { PROJECT_URLS } from "../../api/ProjectsUrls";

interface childrenProps {
  dataIn?: any,
  loadTableData: () => void
}

const CreateProject:React.FC<childrenProps> = ({dataIn, loadTableData}) => {
  const [formData, setFormData] = useState({
    project_name: "",
    roles: [],
  });
  const [roles, setRoles] = useState([])
  const { setLoading, closeModal} = useSiteContext();
  
  useEffect(()=>{
    const subscription = get("role/get_all_select").subscribe((response) => {      
      setRoles(response.data.data);
    });
    return () => subscription.unsubscribe();
  },[])
  
  useEffect(()=>{
    if(dataIn){
      let updatedForm = {
        project_name: dataIn?.project_name,
        roles: dataIn?.roles,
      }
      setFormData(updatedForm)
    }
  },[])

  
  const validations = {
    project: [
      SmartValid.required("Project name is required"),
      // SmartValid.minLength("Minimum 4 Digit", 4),
      // SmartValid.maxLength("Maximum 15 Digit", 15),
    ],
    roles: [
      SmartValid.required("Role is required"),
     
    ],
  };

  const formElements:SmartFormInterFace.SmartFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: "7",
      name: "project_name",
      element: {
        classList:["smart-form-input"],
        label: "Project Name",
        placeHolder: "Enter your Project Name",
        isRequired:true,
        validations: validations.project,
        leftIcon: "fa-briefcase",
        inputProps:{ 
          disabledFunction:()=>{
            if(dataIn) return true
          } 
        }
      },
    },
    {
      type: "SELECT_BOX",
      width: "7",
      name: "roles",
      element: {
        classList:["smart-form-input"],
        label: "Contributor Roles",
        placeHolder: "Select Roles",
        isRequired:true,
        options: roles,
        validations: validations.roles,
        isMulti: true,
        // inputProps:{ 
        //   disabledFunction:()=>{
        //     if(dataIn) return true
        //   } 
        // },
      },
    },
    {
      type: "BUTTON",
      width: "12",
      name:"",
      class_name: "has-text-right",
      element: {
        label: "Save",
        classList: ["smart-action-button"],
        onClick: handleSave,
      },
    },
  ];

  const handleInputChange = (name: string, value: string) => {
    const val = (name == "role") ? [value] : value
    setFormData((prev) => ({ ...prev, [name]: val }));
  };

  const getPayload= ()=>{
    if(dataIn){
      return { 
        id: dataIn?.ID, 
        projectName: formData?.project_name, 
        roles: formData?.roles,
      }
    }else { 
      return {
        projectName: formData?.project_name, 
        roles: formData?.roles,
    }
  }
  }

  function handleSave () {
    if(formData?.project_name == "") return showNotification("error","Please insert the Project Name");
    setLoading(true);
    const payload = getPayload();
    const api = dataIn ? PROJECT_URLS.DELETE : PROJECT_URLS.INSERT
    const subscription = post(api,payload).subscribe((response) => {
      setLoading(false);
      setFormData({
        project_name: "",
        roles: [],
      });
      showNotification("success","Project Created Successfully")
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
  };
  };
  return (
    <div className="sd-pdf-form">  
      <SmartSoftForm
        formData={formData}
        setFormData={handleInputChange}
        elements={formElements}
      />
    </div>
  );
}

export default CreateProject;
